var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ErrorPage',{attrs:{"page-title":_vm.pageInfo.title,"message":_vm.pageInfo.message,"no-btn":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }